import { render, staticRenderFns } from "./rules_privacy.vue?vue&type=template&id=1b5331e7&scoped=true&"
import script from "./rules_privacy.vue?vue&type=script&lang=js&"
export * from "./rules_privacy.vue?vue&type=script&lang=js&"
import style0 from "./rules_privacy.vue?vue&type=style&index=0&id=1b5331e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5331e7",
  null
  
)

export default component.exports